import { render } from "./CloseGreen.vue?vue&type=template&id=096b19f9"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/CloseGreen.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "096b19f9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('096b19f9', __exports__)) {
    api.reload('096b19f9', __exports__)
  }
  
  module.hot.accept("./CloseGreen.vue?vue&type=template&id=096b19f9", () => {
    api.rerender('096b19f9', render)
  })

}


export default __exports__